import { jSith } from "../jquery-replacement";
import { S25Date } from "./s25.date";
import { shallowSort as arrayShallowSort } from "./s25.shallow.sort";

export namespace S25ArraySort {
    export const shallow = arrayShallowSort;

    export function stable(arr: any[], cmp: (a: any, b: any) => number) {
        const positions: any[] = [];
        jSith.forEach(arr, function (i: number, e: any) {
            positions.push({
                position: i,
                element: e,
            });
        });

        return positions.sort(function (a: any, b: any) {
            const cmpResult = cmp(a.element, b.element);
            if (cmpResult === 0) {
                return a.position - b.position;
            }
            return cmpResult;
        });
    }

    export function multiProps(arr: any[], properties?: string[], types?: string[], desc?: boolean[]) {
        if (properties) {
            properties.reverse();
            jSith.forEach(properties, function (i: number, p: string) {
                let type: string = null;
                if (types && types.length > i) {
                    type = types[i];
                }

                let isDesc: boolean = false;
                if (desc && desc.length > i) {
                    isDesc = desc[i];
                }

                stable(arr, function (a: any, b: any) {
                    let aVal: any = a[p];
                    let bVal: any = b[p];

                    if (type === "number") {
                        aVal = Number(aVal);
                        bVal = Number(bVal);
                    } else if (type === "date") {
                        aVal = S25Date.toS25ISODateTimeStr(aVal);
                        bVal = S25Date.toS25ISODateTimeStr(bVal);
                    }

                    if (aVal < bVal) {
                        return isDesc ? 1 : -1;
                    } else if (aVal > bVal) {
                        return isDesc ? -1 : 1;
                    } else {
                        return 0;
                    }
                });
            });
        }
    }

    export function numeric() {
        return function (a: any, b: any) {
            if (Number(a) < Number(b)) {
                return -1;
            } else if (Number(a) > Number(b)) {
                return 1;
            } else {
                return 0;
            }
        };
    }

    export function shallowMultProps(
        properties: string[],
        delimiter?: string,
        defaultVal?: any,
        isDesc?: boolean,
        transformF?: Function,
    ) {
        delimiter = jSith.coalesce(delimiter, "$$$"); //safe-ish delimiter
        defaultVal = jSith.coalesce(defaultVal, "~"); //default to last position
        return function (a: any, b: any) {
            let aVal = "",
                bVal = "";
            jSith.forEach(properties, function (key: any, p: any) {
                aVal += "" + jSith.coalesce((transformF && transformF(a[p])) || a[p], defaultVal) + delimiter;
                bVal += "" + jSith.coalesce((transformF && transformF(b[p])) || b[p], defaultVal) + delimiter;
            });

            aVal = aVal.toLowerCase();
            bVal = bVal.toLowerCase();

            if (aVal < bVal) {
                return isDesc ? 1 : -1;
            } else if (aVal > bVal) {
                return isDesc ? -1 : 1;
            } else {
                return 0;
            }
        };
    }

    export function shallowDates(startDtProp: string, endDtProp: string) {
        const props: string[] = [startDtProp];
        endDtProp && props.push(endDtProp);
        return shallowMultProps(props, null, null, null, S25Date.toS25ISODateTimeStr);
    }

    export function alphaNum() {
        return function (a: any, b: any) {
            if (Number(a) && !Number(b)) {
                return -1;
            } else if (!Number(a) && Number(b)) {
                return 1;
            } else if (Number(a) && Number(b)) {
                return a - b;
            } else if (!Number(a) && !Number(b)) {
                if (a.toLowerCase() < b.toLowerCase()) {
                    return -1;
                } else if (a.toLowerCase() > b.toLowerCase()) {
                    return 1;
                } else {
                    return 0;
                }
            }
        };
    }
}
